<template>
  <div class="w-full">
    <div class="flex flex-col">
      <i18n-t
        scope="global"
        keypath="modules.order.marketOrderConfirm"
        tag="span"
        class="text-c1 font-medium"
      >
        <template #marketPrice>
          <NText variant="caption1" weight="bold">
            {{ t('modules.order.priceType.marketPrice.title') }}
          </NText>
        </template>

        <template #instrumentName>
          <NText variant="caption1" weight="medium">
            {{ props.instrumentName }}
          </NText>
        </template>

        <template #type>
          <NText variant="caption1" weight="medium">
            {{ props.type === 'buy' ? t('common.buy') : t('common.sell') }}
          </NText>
        </template>
      </i18n-t>

      <NText
        v-if="description"
        class="text-neutral-secondary px-2 mt-5"
        variant="caption1"
      >
        {{ description }}
      </NText>
    </div>

    <div class="flex justify-center mb-1 mt-6 gap-4 w-full">
      <NButton
        v-gid="{
          module: 'order',
          screen: 'home',
          section: 'offlineOrderConfirmDialog',
          component: 'confirmOrderButton',
        }"
        variant="fill"
        color="green"
        class="flex-1"
        @click="handleConfirmOrder"
      >
        <NText variant="caption1" weight="bold">
          {{ t('common.yes') }}
        </NText>
      </NButton>

      <NButton variant="flat" color="gray" class="flex-1" @click="remove()">
        <NText variant="caption1" weight="bold">
          {{ t('common.refuse') }}
        </NText>
      </NButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useDialog } from '@negar/core';

type TOfflineOrderConfirmDialogProps = {
  instrumentName: string;
  type: 'sell' | 'buy';
  description?: string;
};

type TOfflineOrderConfirmDialogEmits = {
  (e: 'confirmOrder'): void;
};

const emit = defineEmits<TOfflineOrderConfirmDialogEmits>();
const props = defineProps<TOfflineOrderConfirmDialogProps>();

const { t } = useI18n();

const { remove } = useDialog();

const handleConfirmOrder = () => {
  emit('confirmOrder');

  remove();
};
</script>
